import { calculateNextNodePosition } from '../../utils/nodePositioning';
import { connectCampaignCard } from './connectCampaignCard';

export const OPTIMISTIC_CAMPAIGN_CARD = 'optimisticCampaignCard';
export const OPTIMISTIC_CAMPAIGN_CARD_FAILED = 'optimisticCampaignCardFailed';

export function announceOptimisticCampaignCard(detail) {
  window.dispatchEvent(new CustomEvent(OPTIMISTIC_CAMPAIGN_CARD, { detail }));
}

export function dropOptimisticCampaignCard(sprintId, taskId) {
  if (!taskId) return;
  window.dispatchEvent(new CustomEvent(OPTIMISTIC_CAMPAIGN_CARD_FAILED, {
    detail: { sprintId, taskId },
  }));
}

/** Insert a connected card immediately, before the nested campaign exists. */
export function placeOptimisticCampaignCard(sprint, { taskId, name, connect, icon } = {}) {
  if (!sprint || !taskId) return sprint;
  const tasks = sprint.tasks || [];
  if (tasks.some((task) => task.id === taskId)) return sprint;

  const source = connect?.sourceTaskId
    ? tasks.find((task) => task.id === connect.sourceTaskId)
    : null;
  const position = source && Number.isFinite(source.x) && Number.isFinite(source.y)
    ? { x: source.x, y: source.y + (connect.mode === 'before' ? -180 : 180) }
    : calculateNextNodePosition(tasks, sprint.nodePositions || {});

  const drafted = {
    id: taskId,
    name: name || 'New campaign',
    status: 'pending',
    creatingCampaign: true,
    createdAt: new Date().toISOString(),
    x: position.x,
    y: position.y,
    ...(icon ? { icon } : {}),
    ...(source ? {
      _replacedSource: {
        id: source.id,
        dependsOn: source.dependsOn,
        unlockConditions: source.unlockConditions,
      },
    } : {}),
  };
  const { tasks: wired, task } = connectCampaignCard(tasks, drafted, connect);
  return {
    ...sprint,
    tasks: [...wired, task],
    nodePositions: {
      ...(sprint.nodePositions || {}),
      [taskId]: position,
    },
  };
}

/** Remove a card that never finished creating, and undo an insert-before rewire. */
export function removeOptimisticCampaignCard(sprint, taskId) {
  if (!sprint || !taskId) return sprint;
  const tasks = sprint.tasks || [];
  const pending = tasks.find((task) => task.id === taskId && task.creatingCampaign);
  if (!pending) return sprint;

  const snapshot = pending._replacedSource;
  const nextTasks = tasks
    .filter((task) => task.id !== taskId)
    .map((task) => {
      if (!snapshot || task.id !== snapshot.id) return task;
      const next = { ...task, dependsOn: snapshot.dependsOn };
      if (snapshot.unlockConditions === undefined) delete next.unlockConditions;
      else next.unlockConditions = snapshot.unlockConditions;
      return next;
    });
  const nodePositions = { ...(sprint.nodePositions || {}) };
  delete nodePositions[taskId];
  return { ...sprint, tasks: nextTasks, nodePositions };
}
